export function fmtMoney(minor, currency = "MYR") {
  if (minor == null || Number.isNaN(minor)) return "—";
  const value = minor / 100;
  return `${currency} ${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
  } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString(undefined, {
      year: "numeric", month: "short", day: "2-digit",
      hour: "2-digit", minute: "2-digit"
    });
  } catch { return iso; }
}

export function toMinor(value) {
  const n = parseFloat(String(value).replace(/[^0-9.\-]/g, ""));
  if (Number.isNaN(n)) return 0;
  return Math.round(n * 100);
}

export function moneyByCurrency(map) {
  const entries = Object.entries(map || {});
  if (entries.length === 0) return "—";
  return entries.map(([c, m]) => fmtMoney(m, c)).join(" · ");
}
